import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Modal } from "Components/General/Modal/GenericModal";
import { I18N_NS } from "Config/i18n";
import { taskAttachmentsStore, SubmitMode } from "../Stores/TaskAttachmentsStore";
import { taskSubmitStore } from "../Stores/TaskSubmitStore";
import { taskCommentsStore } from "Pages/Project/Tasks/Stores/TaskCommentsStore";
import { AccessRightsForm } from "Components/General/AccessRightsForm";

export const TaskAccessRightsModal = withTranslation([I18N_NS.PROJECT, I18N_NS.GENERAL])(
  observer(
    class extends React.Component<WithTranslation> {
      private submit: { [key in SubmitMode]: (v: API_TaskRequestData | API_Comment) => Promise<void> } = {
        TASK_EDIT: (values: API_TaskRequestData) => taskSubmitStore.editTask(values),
        TASK_CREATE: (values: API_TaskRequestData) => taskSubmitStore.createTask(values),
        COMMENT_EDIT: (values: API_Comment) => taskCommentsStore.editComment(values),
        COMMENT_CREATE: (values: API_Comment) => taskCommentsStore.createComment(values),
      };

      get hintText() {
        const { t } = this.props;
        const { accessException, accessInternalUsernames } = taskAttachmentsStore;
        // if errorUsers email lists are empty - don't return hint text
        if (!accessInternalUsernames?.length) {
          return null;
        }
        return (
          <>
            {accessException === "ACCESS_TYPE" ? (
              <p>{t(`The following users:`)}</p>
            ) : (
              <p>{t(`The following external recipients:`)}</p>
            )}
            <ul>
              {accessInternalUsernames.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              {t(
                // eslint-disable-next-line max-len
                "have no access rights for the new attached files. You can now allow them to access these files when they open this task."
              )}
              &nbsp;
              {accessException === "ACCESS_TYPE" ? (
                <span>{t("Access rights within the Documents module remain untouched (still no access there).")}</span>
              ) : (
                <span></span>
              )}
            </p>
          </>
        );
      }

      handleClose = () => {
        const { toggleAccessModal, clearNewAttachedFiles } = taskAttachmentsStore;
        clearNewAttachedFiles();
        toggleAccessModal();
      };
      render() {
        const { t } = this.props;
        const { isAccessVisible, accessException, mode } = taskAttachmentsStore;
        return (
          <Modal
            title={t(`Task – define ${accessException === "PIN" ? "external" : "internal"} access`)}
            open={isAccessVisible}
            footer={null}
            destroyOnHidden={true}
            maskClosable={false}
            onCancel={this.handleClose}
            width={`100%`}
            style={{ maxWidth: 800 }}
            zIndex={1015}
          >
            <AccessRightsForm
              fromModule="TASK"
              accessType={accessException}
              onClose={this.handleClose}
              onSubmit={(values) => this.submit[mode](values)}
              hintText={this.hintText}
              isLoading={taskSubmitStore.state === "LOADING"}
            />
          </Modal>
        );
      }
    }
  )
);
